
export default {
  namespaced: true,
  state: {
    userData: null,
  },
  getters: {
    getUserData: state => {
      if (state.userData === null) {
        state.userData = JSON.parse(localStorage.getItem('userData'))
      }
      return state.userData
    },
  },
  mutations: {
    SET_USER_DATA(state, val) {
      state.userData = val
    },
  },
  actions: {},
}
